import { ApiClient } from './client';
import { ensureGuestToken } from './token-manager';

// Search plugin uses /api-bf/ base URL
const SEARCH_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';

const client = new ApiClient(SEARCH_BASE_URL);

export const searchApi = {
  get: async <T>(endpoint: string) => {
    await ensureGuestToken();
    return client.get<T>(endpoint);
  },
  post: async <T>(endpoint: string, data?: unknown) => {
    await ensureGuestToken();
    return client.post<T>(endpoint, data);
  },
};
